<template>
  <div class="modal-window">
    <div class="modal-content">
      <div class="modal-body">
        <div class="modal-title">
          <slot name="modalTitle"> {{ title | capitalize }}?</slot>
        </div>
        <div class="modal-message">
          <slot name="modalMessage">
            {{ $t('components.confirmModal.defaults.message') }}
          </slot>
        </div>
        <div class="modal-data">
          <slot name="modalData"></slot>
        </div>
      </div>

      <div class="modal-actions">
        <TolButton
          v-if="!isInfoModal"
          :label="$t('components.confirmModal.defaults.continue')"
          button-type="major"
          :icon-name="iconName"
          class="confirm-btn ok"
          :disabled="!isContinueEnabled"
          @click="onContinueClick"
        />
        <TolButton
          v-if="!isInfoModal"
          :label="$t('components.confirmModal.defaults.cancel')"
          button-type="major"
          icon-name="times"
          class="confirm-btn cancel"
          @click="onCancelClick"
        />
        <TolButton
          v-if="isInfoModal"
          :label="$t('components.confirmModal.defaults.okay')"
          button-type="major"
          icon-name="check"
          class="confirm-btn ok"
          @click="onOkayClick"
        />
        <TolButton
          v-if="isYesNoModal"
          :label="$t('components.confirmModal.defaults.yes')"
          button-type="major"
          icon-name="check"
          class="confirm-btn ok"
          @click="onYesClick"
        />
        <TolButton
          v-if="isYesNoModal"
          :label="$t('components.confirmModal.defaults.no')"
          button-type="major"
          icon-name="times"
          class="confirm-btn cancel"
          @click="onCancelClick"
        />
      </div>
      <div v-if="!isInfoModal" class="comment">
        <label for="comment"> {{ $t('components.confirmModal.defaults.comment') }}:</label>
        <InputField id="comment" v-model="comment" name="comment" class="comment-value" />
      </div>
    </div>
  </div>
</template>

<script>
import TolButton from './TolButton';
import InputField from './InputField';

export default {
  name: 'ConfirmModal',
  components: {
    TolButton,
    InputField
  },
  props: {
    title: {
      type: String,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    isInfoModal: {
      type: Boolean,
      default: false
    },
    isYesNoModal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      comment: ''
    };
  },
  computed: {
    isContinueEnabled() {
      return this.action === 'APPROVE' || (this.comment && this.comment.length > 0);
    },
    actionWithComment() {
      return { action: this.action, comment: this.comment };
    },
    iconName() {
      return this.isContinueEnabled ? 'check' : 'ban';
    }
  },
  methods: {
    onContinueClick() {
      this.$emit('continue-action', this.actionWithComment);
    },
    onCancelClick() {
      this.$emit('cancel-action', this.action);
    },
    onOkayClick() {
      this.$emit('okay-action');
    },
    onYesClick() {
      this.$emit('yes-action', this.action);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/colors.scss';
@import '../styles/variables.scss';

.modal-window {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: $slate-grey-transparent;
  z-index: 999;

  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

.modal-content {
  width: 30rem;

  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  background: $white;
  color: $black-grey;

  .modal-body {
    display: inline-block;
    padding: 1.5rem 2.5rem;
    width: 20rem;
  }
  .modal-actions {
    display: inline-block;
    width: 10rem;
  }
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 400;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid $row-border;
}

.modal-message {
  padding-bottom: 0.5rem;
}
.modal-data {
  font-weight: bold;
}
.confirm-btn {
  width: 10rem;
  opacity: 1;
  text-transform: uppercase;
  position: fixed;
  padding: 0.8rem 3rem;
  font-size: 0.5rem;
  font-weight: bold;
  color: $white;
  pointer-events: auto;
  &:hover {
    cursor: pointer;
  }
}
.ok {
  top: 25%;
  left: 70%;
  height: 40px;
}
.cancel {
  top: 55%;
  left: 70%;
  background-color: $red;
  height: 40px;
}
.comment {
  display: block;
  padding-left: 40px;
  padding-bottom: 10px;
  label {
    padding-right: 5px;
  }
}

.comment-value {
  display: inline-block;
  width: 75%;
}
</style>
